export enum MaintenanceForwardingsDirectiveEntryKlass {
  DiagnosticEntry = 'Maintenance::Directive::DiagnosticEntry',
  ExecutionEntry = 'Maintenance::Directive::ExecutionEntry',
  ScrapEntry = 'Maintenance::Directive::ScrapEntry',
}
